import { useQuery } from '@tanstack/react-query';

import { queries } from '../../../../common/api/queryKeys/queries';

export const useInitialEnquiry = (offerId) => {
    return useQuery(queries.offers.detail(offerId)._ctx.initialEnquiry);
};
